export enum ProductFamilyType {
  Black = 'Black',
  White = 'White',
  Other = 'Other'
}
